import React from "react";

export const MapPoint = () => (

    <img
      src="/man_icons_flag.svg"
      className="man-marker"
    />

);

export default MapPoint;